module.exports = __webpack_public_path__ + "img/fd_joined_btn.36c6cde9.png";